import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, Button } from '@avangard/ui/core';

type FinishTestButtonProps = {
    withoutAnswerQuestionsIndex: number[];
    onFinish: () => void | Promise<void>;
    onClick?: () => void | Promise<void>;
};

const FinishTestButton = (props: FinishTestButtonProps): React.ReactElement => {
    const { withoutAnswerQuestionsIndex, onClick, onFinish } = props;

    const { t } = useTranslation(['testing']);

    const hasQuestions = withoutAnswerQuestionsIndex.length !== 0;
    const questionString = withoutAnswerQuestionsIndex.join(', ');

    const handleFinish = (): void => {
        onFinish();
    };

    if (hasQuestions) {
        return (
            <Dialog
                title={t('testing:blocks.titles.not_all_questions_answered')}
                cancelText={t('testing:actions.cancel_test') ?? ''}
                acceptText={t('testing:actions.return_to_test') ?? ''}
                content={
                    <>
                        {t('testing:blocks.titles.questions_without_answers.part_1')}{' '}
                        <strong>{questionString}</strong>{' '}
                        {t('testing:blocks.titles.questions_without_answers.part_2')}
                    </>
                }
                onCancel={handleFinish}
                {...props}
            >
                {dialogProps => {
                    const { handleOpen } = dialogProps;

                    const handleClickOpen = (): void => {
                        onClick?.();
                        handleOpen();
                    };

                    return (
                        <Button onClick={handleClickOpen}>
                            {t('testing:actions.cancel_test')}
                        </Button>
                    );
                }}
            </Dialog>
        );
    }

    return (
        <Dialog
            title={t('testing:blocks.titles.cancel_test')}
            cancelText={t('testing:actions.return_to_test') ?? ''}
            acceptText={t('testing:actions.cancel_test') ?? ''}
            onAccept={handleFinish}
            {...props}
        >
            {dialogProps => {
                const { handleOpen } = dialogProps;

                const handleClickOpen = (): void => {
                    onClick?.();
                    handleOpen();
                };

                return (
                    <Button onClick={handleClickOpen}>{t('testing:actions.cancel_test')}</Button>
                );
            }}
        </Dialog>
    );
};

export { FinishTestButton };
